import { useState, useEffect } from 'react';
import { Box, Card, Divider, Grid, Typography, useTheme } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitleDefault from '../default/DialogTitleDefault';
import { ButtonBasic, DateRangeMaxSeven, SelectEstadoConsulta, SelectUser } from '../../components';
import FechaFunction from '../../function/FechaFunction';
import DashboardService from '../../services/dashboard.service';

function ModalFilterDashConsultas({
    show,
    hideModal,
    filtroTotal,
    setFiltroTotal,
    setCountFilter,
    itemsOriginal,
    primeraCarga,
    setItems,
    fechaSelect,
    setFechaSelect,
    setItemsOriginal
}) {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const handleClose = () => hideModal();
    const [isLoading, setIsLoading] = useState(false);
    const [estado, setEstado] = useState(filtroTotal?.estado || []);
    const [segmento, setSegmento] = useState(filtroTotal?.segmento || []);
    const [creadoPor, setCreadoPor] = useState(filtroTotal?.autorId || []);
    const [fechas, setFechas] = useState({
        startDate: new Date(),
        endDate: new Date()
    });

    useEffect(() => {
        if (fechaSelect?.startDate && fechaSelect?.endDate) {
            let startDate, endDate;
            if (typeof fechaSelect.startDate === 'string') {
                startDate = new Date(fechaSelect.startDate + 'T00:00:00');
            } else {
                startDate = new Date(fechaSelect.startDate);
            }
            if (typeof fechaSelect.endDate === 'string') {
                endDate = new Date(fechaSelect.endDate + 'T00:00:00');
            } else {
                endDate = new Date(fechaSelect.endDate);
            }
            setFechas({ startDate, endDate });
        }
    }, [fechaSelect]);

    const nuevoFiltro = (itemsOrigin) => {
        if (estado?.length > 0) {
            itemsOrigin = itemsOrigin.filter(obj => estado.includes(obj.estadoConsulta_con));
        }
        if (segmento?.length > 0) {
            itemsOrigin = itemsOrigin.filter(obj => segmento.includes(obj.segmento_con));
        }
        if (creadoPor?.length > 0) {
            itemsOrigin = itemsOrigin.filter(obj => creadoPor.includes(obj.createdPersonaId_con));
        }
        primeraCarga(itemsOrigin);
        setItems(itemsOrigin);
    };

    const onSubmit = async () => {
        setIsLoading(true);
        setFiltroTotal({
            ...filtroTotal,
            estado,
            segmento,
            autorId: creadoPor,
        });
        const suma = estado?.length + segmento?.length + creadoPor?.length;
        setCountFilter(suma);

        const fechaIni = fechas?.startDate ? FechaFunction.format(fechas.startDate, 'yyyy-MM-dd') : null;
        const fechaFin = fechas?.endDate ? FechaFunction.format(fechas.endDate, 'yyyy-MM-dd') : null;

        try {
            const resp = await DashboardService.gralConsulta({
                fecIni: fechaIni,
                fecFin: fechaFin,
                estado,
                segmento,
                autorId: creadoPor
            });
            const data = resp?.data || resp;
            setFechaSelect({ startDate: fechaIni, endDate: fechaFin });
            setItemsOriginal(data);
            primeraCarga(data);
            setItems(data);
        } catch (error) {
            console.error('Error al cargar datos:', error);
        }
        setIsLoading(false);
        handleClose();
    };

    return (
        <Dialog open={show} disableEscapeKeyDown maxWidth='md' fullWidth className='side'>
            <Box sx={{ background: isDarkMode ? '#2d3a52' : '#fff' }} className='side'>
                <DialogTitleDefault id="filter-consultas" onClose={handleClose}>
                    <Typography sx={{ flex: 1, textAlign: 'center', color: isDarkMode ? '#e0e0e0' : '#000', fontWeight: 'bold' }} variant='h5'>
                        FILTRAR DATOS - CONSULTAS
                    </Typography>
                </DialogTitleDefault>
                <Divider sx={{ background: isDarkMode ? '#3d4a62' : 'gray' }} />
                <DialogContent className='side'>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Card sx={{ boxShadow: 4, borderRadius: 4, background: isDarkMode ? '#1F2A40 !important' : '#fff !important', p: 2 }}>
                                <Typography sx={{ color: isDarkMode ? '#e0e0e0' : '#000', fontWeight: 'bold', textAlign: 'center' }}>
                                    Rango de Fechas
                                </Typography>
                                <DateRangeMaxSeven
                                    minDate={new Date('2023-11-01')}
                                    initianDate={fechas}
                                    onChange={(e) => {
                                        let startDate, endDate;
                                        if (e?.startDate) {
                                            startDate = new Date(e.startDate);
                                            startDate.setHours(0, 0, 0, 0);
                                        }
                                        if (e?.endDate) {
                                            endDate = new Date(e.endDate);
                                            endDate.setHours(23, 59, 59, 999);
                                        } else if (e?.startDate) {
                                            endDate = new Date(e.startDate);
                                            endDate.setHours(23, 59, 59, 999);
                                        }
                                        if (e?.startDate) {
                                            setFechas({ startDate, endDate });
                                        }
                                    }}
                                />
                            </Card>
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <Typography sx={{ color: isDarkMode ? '#e0e0e0' : '#000', fontWeight: 'bold' }}>Estado</Typography>
                            <SelectEstadoConsulta
                                isMulti
                                value={estado}
                                onChange={(opt) => {
                                    setEstado(opt ? opt.map(op => op.value) : []);
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <Typography sx={{ color: isDarkMode ? '#e0e0e0' : '#000', fontWeight: 'bold' }}>Creado por:</Typography>
                            <SelectUser
                                isMulti
                                filter='all'
                                value={creadoPor}
                                onChange={(opt) => {
                                    setCreadoPor(opt.map(op => op.value));
                                }}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
                    <ButtonBasic
                        textButton='Cancelar'
                        variant='wk'
                        color='cancel'
                        onClick={() => handleClose()}
                        sx={{ mb: 2 }}
                    />
                    <ButtonBasic
                        textButton='Guardar'
                        variant='wk'
                        color='nextStep'
                        onClick={() => onSubmit()}
                        sx={{ mb: 2 }}
                        isLoading={isLoading}
                    />
                </DialogActions>
            </Box>
        </Dialog>
    );
}

export default ModalFilterDashConsultas;
